import { render, staticRenderFns } from "./AdminHoursBookedByClient.vue?vue&type=template&id=32c90e0a"
import script from "./AdminHoursBookedByClient.vue?vue&type=script&lang=js"
export * from "./AdminHoursBookedByClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports